import { h, Component, Fragment } from 'preact'
import PostAPI from '../api/PostAPI'
import Posts from '../components/Posts'
import Loader from '../components/Loader'
import SearchFilter from '../components/SearchFilter'
import Filters from './Filters'
import Map from './Map'
import Pagination from '../components/Pagination'

// Tell Babel to transform JSX into h() calls:
/** @jsx h */

class App extends Component {
  constructor(props) {
    super(props)

    window.addEventListener('popstate', event => {
      this.componentDidMount()
    })

    this.state = {
      posts: [],
      allPosts: [],
      count: Number(this.props.labels.count),
      currentPage: 1,
      offset: 0,
      currentTerms: {
        house_status: '',
        house_type: '',
        house_capacity: '',
        house_bedrooms: ''
      },
      totalAmountPosts: null,
      loadedAllPosts: false,
      isLoading: true,
      error: false,
      filtered: false,
      searchText: '',
      showMap: false
    }
  }

  componentDidMount() {
    // Check if current_page is set in URL. If so, load with params
    const queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)
    const currentPage = urlParams.get('current_page')

    if (currentPage) {
      this.setState(
        {
          posts: [],
          currentPage: Number(currentPage),
          offset: this.state.count * Number(currentPage) - this.state.count
        },
        this.fetchPosts
      )
    } else {
      this.fetchPosts()
    }
  }

  // Function to fetch posts
  fetchPosts() {
    this.setState({ isLoading: true })

    PostAPI.all(this.state)
      .then(response => {
        this.setState({
          totalAmountPosts: response.headers.get('x-wp-total')
        })
        return response.json()
      })
      .then(data => {
        this.setState({
          posts: [...this.state.posts, ...data],
          loadedAllPosts: false,
          isLoading: false
        })
      })
      .then(() => {
        // Load all posts as backup
        if (this.state.allPosts.length === 0) {
          PostAPI.all({
            count: 999,
            offset: 0,
            currentTerms: {
              house_status: '',
              house_type: '',
              house_capacity: '',
              house_bedrooms: ''
            }
          })
            .then(response => {
              return response.json()
            })
            .then(data => {
              this.setState({
                allPosts: [...this.state.allPosts, ...data]
              })
            })
        }
      })
      .catch(error => {
        console.log(error)
        this.setState({
          error: true,
          isLoading: false
        })
      })
  }

  // Check if all posts are loaded
  verifyLoadedAllPosts() {
    if (this.state.totalAmountPosts === this.state.posts.length) {
      return this.setState({
        loadedAllPosts: true
      })
    }

    return false
  }

  // Handle filter
  handleTermChoice(currentTerm, taxonomy) {
    const currentTerms = this.state.currentTerms
    currentTerms[taxonomy] = currentTerm

    this.setState(() => {
      return {
        currentTerms: currentTerms,
        posts: [],
        offset: 0,
        filtered: true
      }
    }, this.fetchPosts)
  }

  handleResetFilters() {
    this.setState(
      {
        currentTerms: {
          house_status: '',
          house_type: '',
          house_capacity: '',
          house_bedrooms: ''
        },
        posts: [],
        offset: 0,
        filtered: false
      },
      this.fetchPosts
    )
  }

  handleSearch(searchText) {
    // Searching while typing
    this.setState({
      searchText: searchText
    })
  }

  handleSearchSubmit() {
    this.setState(
      {
        posts: [],
        offset: 0,
        currentPage: 1
      },
      this.fetchPosts
    )
  }

  // Set activeHover to show the right marker on map
  handleMouseEnter(e) {
    let posts = [...this.state.posts]
    let allPosts = [...this.state.allPosts]
    // Get the right post and set hoverActive to true
    const postIndex = posts.findIndex(
      obj => obj.id == e.currentTarget.dataset.target
    )
    postIndex !== -1 ? (posts[postIndex].activeHover = true) : null

    const allPostsIndex = allPosts.findIndex(
      obj => obj.id == e.currentTarget.dataset.target
    )
    allPostsIndex !== -1 ? (allPosts[allPostsIndex].activeHover = true) : null
    this.setState({ posts, allPosts })
  }

  handleMouseLeave(e) {
    let posts = [...this.state.posts]
    let allPosts = [...this.state.allPosts]
    // Get the right post and set hoverActive to false
    const postIndex = posts.findIndex(
      obj => obj.id == e.currentTarget.dataset.target
    )
    postIndex !== -1 ? (posts[postIndex].activeHover = false) : null

    const allPostsIndex = allPosts.findIndex(
      obj => obj.id == e.currentTarget.dataset.target
    )

    allPostsIndex !== -1 ? (allPosts[allPostsIndex].activeHover = false) : null
    this.setState({ posts, allPosts })
  }

  handleLoadMore() {
    this.setState(prevState => {
      return {
        offset: prevState.offset + this.state.count
      }
    }, this.fetchPosts)
  }

  updateURL(page) {
    // Update URL so page is set on refresh
    if (history.pushState) {
      var newurl =
        window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname +
        `?current_page=${page}`
      window.history.pushState({ path: newurl }, '', newurl)
    }
  }

  handlePageClick(e) {
    // Multiply the count by the currentPage to get the correct offset
    if (e.currentTarget.dataset.page) {
      window.scrollTo(0, 0)
      this.updateURL(e.currentTarget.dataset.page)
      this.setState(
        {
          posts: [],
          currentPage: Number(e.currentTarget.dataset.page),
          offset:
            this.state.count * Number(e.currentTarget.dataset.page) -
            this.state.count
        },
        this.fetchPosts
      )
    }
  }

  // Toggle the state to show/hide map
  toggleMapView(showMap) {
    this.setState({ showMap });
    if (showMap) {
      document.body.style.overflow = 'hidden'; // Prevent scrolling when map is fullscreen
    } else {
      document.body.style.overflow = ''; // Restore scrolling
    }
  }

  render() {
    return (
      <div className="c-housing-app">
        <div className="c-housing-app__container">
          <div className="o-container">
            <div className="c-housing-app__posts-container ">
              <div className="c-housing-app__posts">
                <div className="c-housing-app__top-bar">
                  <h1 className="c-housing-app__title">
                    {this.props.labels.title}
                  </h1>
                  <a
                    className="c-button c-button--primary c-housing-app__button"
                    href={this.props.labels.button.url}
                  >
                    {this.props.labels.button.content}
                  </a>
                </div>

                {/* Buttons to toggle views */}
                <div className={`c-housing-app__toggle-buttons ${this.state.showMap ? 'c-housing-app__toggle-buttons--map-active' : ''} u-flex`}>
                  <div className={`c-toggle-button u-flex ${!this.state.showMap ? 'c-toggle-button--active' : ''}`} onClick={() => this.toggleMapView(false)}>
                    <svg className="c-icon c-toggle-button__icon">
                      <use href="#toggle-list" xlinkHref="#toggle-list" />
                    </svg>
                    Lijst weergave
                  </div>
                  <div className={`c-toggle-button u-flex ${this.state.showMap ? 'c-toggle-button--active' : ''}`} onClick={() => this.toggleMapView(true)}>
                    <svg className="c-icon c-toggle-button__icon">
                      <use href="#toggle-location" xlinkHref="#toggle-location" />
                    </svg>
                    Kaart weergave
                  </div>
                </div>

                <div className={`c-housing-app__filters-wrapper ${!this.state.showMap ? 'c-housing-app__filters-wrapper--active' : ''}`}>
                  <SearchFilter
                    onSearch={this.handleSearch.bind(this)}
                    onSubmit={this.handleSearchSubmit.bind(this)}
                    placeholder={this.props.labels.placeholder}
                  />
                  <Filters
                    filters={this.state.currentTerms}
                    onSelectTerm={this.handleTermChoice.bind(this)}
                    onResetFilter={this.handleResetFilters.bind(this)}
                    filtered={this.state.filtered}
                  />
                </div>

                {this.state.isLoading ? (
                  <Loader />
                ) : (
                  <Fragment>
                    <div className={`c-housing-app__posts-wrapper ${ !this.state.showMap ? 'c-housing-app__posts-wrapper--active' : ''}`}>
                      <Posts
                        posts={this.state.posts}
                        allPosts={this.state.allPosts}
                        loading={this.state.isLoading}
                        error={this.state.error}
                        handleMouseEnter={this.handleMouseEnter.bind(this)}
                        handleMouseLeave={this.handleMouseLeave.bind(this)}
                        searchText={this.state.searchText}
                      />
                      <Pagination
                        count={this.state.count}
                        offset={this.state.offset}
                        currentPage={this.state.currentPage}
                        totalAmountPosts={this.state.totalAmountPosts}
                        handlePageClick={this.handlePageClick.bind(this)}
                      />
                    </div>
                  </Fragment>
                )}
              </div>
            </div>
          </div>
          <div className={`c-housing-app__maps-container ${this.state.showMap ? 'c-housing-app__maps-container--active' : ''}`}>
            <Map
              posts={
                (this.state.filtered || this.state.searchText !== '') &&
                this.state.posts.length > 0
                  ? this.state.posts
                  : this.state.allPosts
              }
            />
          </div>
        </div>
      </div>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/js/housing/containers/App.js